import { Table, Row, Col, Container } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { useState, useEffect, useContext } from "react";
import Card from "react-bootstrap/Card";
import { ArcherContainer } from "react-archer";
import { TaskContext } from "../components/TaskContext";
import { apiRequest } from "../components/Config";

export default function TaskStory({ insertId }) {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const { taskId } = useContext(TaskContext);

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!userData) return;
      try {
        const response = await apiRequest(`taskchatstory/${taskId}`, "GET");
        console.log("STORY: ", response);
        if (Array.isArray(response)) {
          setData(response);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    //if (userData && userData.userId && taskId > 0) {
    fetchData();
    //}
  }, [userData, taskId, insertId]);

  if (taskId === 0) {
    return (
      <Container>
        <h4>Zlecenie ID: {taskId}</h4>
        <p>
          Prawdopodobnie odświeżona została zawartość strony. Przejdź ponownie
          do Zleceń i wybierz ponownie...
        </p>
      </Container>
    );
  }

  const getHeaderStyle = (idPerm) => {
    switch (idPerm) {
      case "1":
        return { backgroundColor: "#FFDAB9", color: "#000" };
      case "3":
        return { backgroundColor: "#c0c0c0", color: "#000" };
      case "2":
        return { backgroundColor: "#E6E6FA", color: "#000" };
      default:
        return {};
    }
  };

  return (
    <ArcherContainer
      strokeColor="blue"
      strokeWidth={2}
      arrowLength={10}
      arrowThickness={6}
    >
      <Container>
        <Table bordered>
          <tbody>
            {data &&
              data.map((item, index) => (
                <tr key={index}>
                  {/* Lewa kolumna - idPerm 1 lub 3 */}
                  <td style={{ width: "50%" }}>
                    {(item.idPerm === "1" || item.idPerm === "3") && (
                      <Card style={{ width: "100%" }}>
                        <Card.Body>
                          {item.pzitbAuthor && (
                            <Row
                              style={{
                                borderTop: "2px solid red",
                                borderBottom: "2px solid red",
                                paddingBottom: "4px",
                                marginBottom: "6px",
                              }}
                            >
                              <Col>{item.pzitbAuthor}</Col>
                              <Col>
                                <b>POCZTA PZITB</b>
                              </Col>
                            </Row>
                          )}
                          {item.reporterMail && (
                            <Row
                              style={{
                                borderTop: "2px solid green",
                                borderBottom: "2px solid green",
                                paddingBottom: "4px",
                                marginBottom: "6px",
                              }}
                            >
                              <Col>{item.pzitbAuthor}</Col>
                              <Col>
                                <b>Korespondencja do Zleceniodawcy</b>
                              </Col>
                            </Row>
                          )}
                          <Row>
                            <Col>
                              <p style={getHeaderStyle(item.idPerm)}>
                                Wysłał:&nbsp;&nbsp;&nbsp;{" "}
                                <b>{item.fullNameFrom}</b>
                              </p>
                            </Col>
                            <Col>
                              <p className="p3">{item.created}</p>
                            </Col>
                          </Row>
                          <p className="p3">Temat: {item.title}</p>
                          <Card.Text
                            onClick={() => toggleRow(index)}
                            style={{ color: "black", cursor: "pointer" }}
                          >
                            {expandedRows[index] ? (
                              item.content
                            ) : (
                              <>
                                {item.content ? item.content.slice(0, 500) : ""}
                                {item.content &&
                                  item.content.length > 50 &&
                                  "[...]"}
                              </>
                            )}
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    )}
                  </td>

                  {/* Prawa kolumna - idPerm 2 */}
                  <td style={{ width: "50%" }}>
                    {item.idPerm === "2" && (
                      <Card style={{ width: "100%" }}>
                        <Card.Body>
                          <Row>
                            <Col>
                              <p style={getHeaderStyle(item.idPerm)}>
                                Wysłał:&nbsp;&nbsp;&nbsp;{" "}
                                <b>{item.fullNameFrom}</b>
                              </p>
                            </Col>
                            <Col>
                              <p className="p3">{item.created}</p>
                            </Col>
                          </Row>
                          <p className="p3">Temat: {item.title}</p>
                          <Card.Text
                            onClick={() => toggleRow(index)}
                            style={{ color: "black", cursor: "pointer" }}
                          >
                            {expandedRows[index] ? (
                              item.content
                            ) : (
                              <>
                                {item.content ? item.content.slice(0, 500) : ""}
                                {item.content &&
                                  item.content.length > 50 &&
                                  "[...]"}
                              </>
                            )}
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Container>
    </ArcherContainer>
  );
}
